import { DateTime } from "luxon";

const ACTIVITY_GROUP_LABELS = ["Today", "This week", "Earlier"] as const;

/** Buckets by calendar day in the reader's zone, taken from `now`. */
export const groupConversationsByActivity = <T extends { lastActivityAt: string }>(
	items: readonly T[],
	now: DateTime,
) => {
	const weekStart = now.startOf("day").minus({ days: 6 });
	const labels = items.map(({ lastActivityAt }) => {
		const at = DateTime.fromISO(lastActivityAt).setZone(now.zone);
		if (at.hasSame(now, "day")) return "Today";
		return at >= weekStart ? "This week" : "Earlier";
	});
	return ACTIVITY_GROUP_LABELS.map((label) => ({
		label,
		items: items.filter((_, index) => labels[index] === label),
	})).filter((group) => group.items.length > 0);
};
